/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { IMAGE_PADDING } from '@appCanvasCommon/interfaces/image-padding.interface';

export enum MILESTONE_SIZE_OFFSET {
	WIDTH = 45,
	HEIGHT = 45,
}

export enum MILESTONE_SIZE_OFFSET2 {
	ACTIVE = 45,
	PULL = 90,
}
